import { Button as AntButton, Modal, Select } from "antd";
import { FC } from "react";
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";
import { ICampusItem } from "../../../../models/campuses.model";
import { RootState } from "../../../../store/rootReducer";

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  nextCampusCode: string;
  setNextCampusCode: (newCampusCode: string) => void;
  onTransferCampus: () => void;
}

const ConfirmTransferModal: FC<IProps> = ({
  visible,
  setVisible,
  nextCampusCode,
  setNextCampusCode,
  onTransferCampus,
}) => {
  const { t } = useTranslation();
  const { campusData } = useSelector((state: RootState) => state.campusData);

  const onClose = () => {
    setNextCampusCode('');
    setVisible(false);
  }

  return (
    <>
      <Modal
        title={t('student.student.title23')}
        visible={visible}
        onCancel={onClose}
        footer={[
          <div className='comm-btn__area justify-content-center'>
            <AntButton
              key="submit"
              className='btn-basic pink'
              onClick={onTransferCampus}
            >
              {t('common.button.confirm')}
            </AntButton>
            <AntButton
              key="cancel"
              className='btn-basic gray'
              onClick={onClose}
            >
              {t('common.button.cancel')}
            </AntButton>
          </div>
        ]}
      >
        <div className="text-center">
          {t('student.student.message55')}<br /><br />
          <div className="flex flex-justify-center">
            <div className="v-line mr-1">
            {t('student.student.text27')}:         
            </div>
            <div className="w-150p">
              <Select
                className="w-100"
                placeholder={t('class.class.placeholder1')}
                value={nextCampusCode} 
                onChange={value => setNextCampusCode(value)}
              >
                {
                  campusData.slice(1).map((item: ICampusItem) => {
                    return (
                      <Select.Option
                        key={item.campusCode}
                        value={item.campusCode}
                      >
                        {item.campusKorName}
                      </Select.Option>
                    )
                  })
                }
              </Select>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default ConfirmTransferModal;
